import { render, staticRenderFns } from "./Monitor.vue?vue&type=template&id=2348ef67&scoped=true&"
import script from "./Monitor.vue?vue&type=script&lang=js&"
export * from "./Monitor.vue?vue&type=script&lang=js&"
import style0 from "./Monitor.vue?vue&type=style&index=0&id=2348ef67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2348ef67",
  null
  
)

export default component.exports